<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="isLoading">
                    <mat-spinner></mat-spinner>
                    <h2>Verifying Email...</h2>
                </div>
                <div *ngIf="!isLoading && !errorMessage">
                    <h2>Email Verification</h2>
                    <p>Please wait while we verify your email address.</p>
                </div>
                <div *ngIf="!isLoading && errorMessage">
                    <h2>Email Verification Failed</h2>
                    <p>{{ errorMessage }}</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>